// extracted by mini-css-extract-plugin
export default {"newBadge":"styles_newBadge__SRKnY","icon":"styles_icon__1AZnl","spatialNavigationActive":"styles_spatialNavigationActive__FTjv8"};